{
  "close": "إغلاق",
  "notifications": "{count, plural, one {# إشعار} other {# إشعارات}}."
}
